export default __webpack_public_path__ + "static/media/35_Kane_lesni_PELZ_upr.f70a7453.mp3";